/// <reference path="../../../../../rcwebmodels/reefercommandstatus.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import DateFormat from 'dateformat';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridToolBar } from '../sharedcomponents/GridToolBar';
import Formatters from '../../actions/Formatters';
import $ from 'jquery';

import { RCUtils } from './../../RCUtils';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';

import * as Exceljs from '../../actions/ExportToExcel.js';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import UserRights from '../../actions/UserRights';
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');


export interface DryCommandStatusGridState {
    rowData: server.CommandStatusUI[],
    columnDefs: any[],
    CommandStatusFilters: DryCommandStatusFilters,
    UserList: server.UserListModel[],
    CommandStatus: server.RefCommandStatusModel[],
    CommandTypes: server.RefCommandTypesModel[],
    pageSize: any,
    gridApiParams: any,
    modelTitle: string;
    popUpHtml: any;
    selectedItems: any[];
    Filters: ForwardCommandParams;
    PreferenceDTTM: any;
}

var self;

export class DryDetailsCommandStatus extends React.Component<any, DryCommandStatusGridState> {
    constructor(props: any) {
        super(props);
        var columnDefs = this.createColumnDefs();
        var filterSet = this.initDetailsCommandStatusFilters();//new DryCommandStatusFilters();
        var ForwardCommandfilterSet = new ForwardCommandParams();
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        this.state = {
            rowData: [], columnDefs: columnDefs, CommandStatusFilters: filterSet, UserList: [], CommandStatus: [], CommandTypes: []
            , pageSize: 25
            , gridApiParams: []
            , modelTitle: ''
            , popUpHtml: ''
            , selectedItems: []
            , Filters: ForwardCommandfilterSet
            , PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm)
        };
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetUsersList')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.UserListModel[]>)
            .then(data => {
                this.setState({ UserList: data });
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GetDryCommandStatus')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.RefCommandStatusModel[]>)
            .then(data => {
                this.setState({ CommandStatus: data });
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GetDryCommandTypes')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.RefCommandTypesModel[]>)
            .then(data => {
                this.setState({ CommandTypes: data });
            });

        self = this;
    }
    initDetailsCommandStatusFilters() {
        var objCommandStatusFilters = new DryCommandStatusFilters();
        objCommandStatusFilters.ReeferIds = "";
        objCommandStatusFilters.RcdIds = "";
        objCommandStatusFilters.CommandTypeCd = "";
        objCommandStatusFilters.FromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        objCommandStatusFilters.ToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        objCommandStatusFilters.CommandStatusId = 0;
        objCommandStatusFilters.UserId = 0;
        
        return objCommandStatusFilters;
    }

    componentWillReceiveProps(nextprops: any) {
        if (nextprops.stateData != undefined && nextprops.stateData != null) {
            nextprops.stateData.dryCommandsData = this.state.rowData;
            this.bindDryCommandsData(nextprops.stateData);
        }
    }

    bindDryCommandsData(stateData: any) {
        var commandStatusData = stateData.dryCommandsData;
        var statusData = stateData.dryDetailsData;
        this.state.CommandStatusFilters.ReeferIds = statusData.AssetNumber;
            this.state.CommandStatusFilters.RcdIds = statusData.RCDID;
        /*
        var modifiedDttm = this.state.PreferenceDTTM;
        var fromDate = moment(new Date(modifiedDttm)).startOf('day').toString();
        var toDate = moment(new Date(modifiedDttm)).endOf('day').toString();
        */
        var toDate = this.props.ToDate;
        var fromDate = this.props.FromDate;

        this.state.CommandStatusFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.CommandStatusFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        this.state.CommandStatusFilters.CommandTypeCd = "-1";
        this.state.CommandStatusFilters.CommandStatusId = -1;

        //setTimeout(() => {
        //    this.setState({ rowData: commandStatusData });
        //}, 50);

        if (this.props.stateData.dryCommandsData != undefined && this.props.stateData.dryCommandsData != null) {
            if (this.props.stateData.dryCommandsData.length == 0) {
                this.ApplyCommandStatusFilter();
            }
            else {
                this.setState({
                    //reeferFormatter: this.props.stateData.reeferFormatter,
                    rowData: this.props.stateData.dryCommandsData
                });
            }
        }
        else
            this.ApplyCommandStatusFilter();

        //if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != []) {
        //    self.state.gridApiParams.paginationGoToFirstPage();
        //} 
    }

    updateDryCommandsDimensions() {
        $("#CommandStatusGrid .ag-root-wrapper-body").css('min-height', $(window).height() - 327);
        $("#CommandStatusGrid .ag-root-wrapper-body").css('height', $(window).height() - 327);
        $("#CommandStatusGrid .ag-root-wrapper-body").css('max-height', $(window).height() - 327);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDryCommandsDimensions.bind(this));
    }

    componentDidMount() {
        this.updateDryCommandsDimensions();
        window.addEventListener("resize", this.updateDryCommandsDimensions.bind(this));
        $(".context-menu").hide();
        $("#contextmenu").hide();
        Excel.preventDefault();
       
       
        
        
        // To make the Modal popups draggable.
        Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
        RCNGWindow.ConfirmWindow.close();
        if (this.props.stateData != undefined && this.props.stateData != null) {
            var stateData = this.props.stateData;
            this.bindDryCommandsData(stateData);
        }
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }

    DryIdchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.CommandStatusFilters;
        var Value: string = event.currentTarget.value;
        filters.ReeferIds = Value;
        this.setState({
            CommandStatusFilters: filters
        });
    }

    RcdIdchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.CommandStatusFilters;
        var Value: string = event.currentTarget.value;
        filters.RcdIds = Value;
        this.setState({
            CommandStatusFilters: filters
        });
    }

    CommandFromDateChange(date) {
        var filters = self.state.CommandStatusFilters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({
            CommandStatusFilters: filters
        });

        this.props.HoldCommandHistoryDates(date, null);
    }

    CommandToDateChange(date) {
        var filters = self.state.CommandStatusFilters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({
            CommandStatusFilters: filters
        });

        this.props.HoldCommandHistoryDates(null, date);
    }

    Statuschange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.CommandStatusFilters;
        var Value: string = event.currentTarget.value;
        if (Value == "-Select-")
            filters.CommandStatusId = -1;
        else
            filters.CommandStatusId = parseInt(Value);
        this.setState({
            CommandStatusFilters: filters
        });
    }

    CommandTypechange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.CommandStatusFilters;
        var Value: string = event.currentTarget.value;
        if (Value == "-Select-")
            filters.CommandTypeCd = "-1";
        else
            filters.CommandTypeCd = Value;
        this.setState({
            CommandStatusFilters: filters
        });
    }

    Userchange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.CommandStatusFilters;
        var Value: string = event.currentTarget.value;
        if (Value == "-Select-")
            filters.UserId = -1;
        else
            filters.UserId = parseInt(Value);
        this.setState({
            CommandStatusFilters: filters
        });
    }

    dryContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Cancel": this.drydetailsCancelAction();
                break;
        }
    }


    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    cancelCommandAction() {
        if (self.state.selectedItems.length > 0) {
            $('#globalLoader').show();
            var commandName = "Cancel";
            self.state.Filters.CommandName = commandName;
            self.state.Filters.SelectedReefers = self.state.selectedItems;
            var forwardCommandParams = JSON.stringify(self.state.Filters);

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/SubmitCancelForwardCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<ValidationSeverityResult>)
                .then(data => {
                    if (data != null && data != undefined) {
                        if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                            PopupWindow.showErrorMessage("Error", data.Result);
                            $(".mm-popup__box__body").css("white-space", "pre-line");
                            return;
                        }
                        RCNGWindow.ConfirmWindow.close();
                    }

                    $("#contextMenuModel .close").click();
                    this.ApplyCommandStatusFilter();
                });
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }
    drydetailsCancelAction() {
        if (self.state.selectedItems.length > 0) {
            var reeferData = self.state.selectedItems;
            var confirmationMessage = "Are you sure you want to cancel the command(s)?"
            RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.cancelCommandAction.bind(this), this.closeConfirmation.bind(this));
        }
    }
    onSortChanged(params: any) {
        params.api.gridOptionsWrapper.gridOptions.api.refreshInMemoryRowModel('filter');
        params.api.gridOptionsWrapper.gridOptions.api.redrawRows();
    }
    getContextMenuItems(params: any) {
        var isEnableContextMenu = UserRights.checkVisibility('124');
        if (isEnableContextMenu == 'show') {
            var flag = false;
            var selected = params.api.getFocusedCell();
            var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
            var tempArray = [];// if sort is clicked save in temp array
            params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                tempArray.push(rowNode);
            });
            var resortitem = tempArray[selected.rowIndex];
            var sortflage = false;
            var reeferid = resortitem.data.ReeferID;
            var submitted = resortitem.data.SubmittedOn;
            params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                if ((NewrowNode.data.SubmittedOn === submitted)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.SubmittedOn == selectedrowNode.data.SubmittedOn) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
            $(".context-menu").show();
            $("#contextmenu").show();
            Excel.preventDefault();

            $(".ag-cell").unbind("contextmenu");
            $(".ag-cell").bind('contextmenu', function (e) {
                $("#contextmenu").show();
                var flag = false;
                var selected = params.api.getFocusedCell();
                var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
                var tempArray = [];// if sort is clicked save in temp array
                params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                    tempArray.push(rowNode);
                });
                var resortitem = tempArray[selected.rowIndex];
                var sortflage = false;
                var reeferid = resortitem.data.ReeferID;
                var submitted = resortitem.data.SubmittedOn;
                params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                    if ((NewrowNode.data.SubmittedOn === submitted)) {
                        selectedrowNode = NewrowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, function (index, item) {
                    if (item.SubmittedOn == selectedrowNode.data.SubmittedOn) {
                        flag = true;
                        return false;
                    }
                });
                if (!flag)
                    params.api.deselectAll();
                params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
                var height = $(window).height() - 200;
                var halfheight = ($(window).height()) / 2;
                var top = e.pageY + 5;
                $('#liCommandsRequiresRight>.dropdown-menu').css("top", "55px");
                var left = e.pageX;

                if (left >= ($(window).width() - 200)) {
                    $(".context-menu").css({
                        top: top + "px",
                        right: 20 + "px",
                        width: 160 + 'px',
                        left: $(window).width() - 200 + 'px'
                    });

                    $('.context-menu').find("ul.dropdown-menu").css("left", "-155px");
                }
                else {
                    $(".context-menu").css({
                        top: top + "px",
                        left: left + "px"
                    });

                    $('.context-menu').find("ul.dropdown-menu").css("left", "155px");
                }
                $(".context-menu").show();
                e.preventDefault();
                return false;
            });

            $(document).contextmenu(function () {
                return false;
            });

            $(document).bind('contextmenu click', function () {
                $(".context-menu").hide();
            });

            $('.context-menu').bind('contextmenu', function () {
                return false;
            });
            $('.context-menu').on('click', 'li', function () {
                $(".context-menu").hide();
            });
        }

    }

    onSelectionChanged(params: any) {
        $("#contextmenu").show();
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        var selectedItems = self.state.selectedItems;
        var selectedItems = self.state.selectedItems;
        self.setState({
            selectedItems: selectedReeferData
        });
        if (selectedReeferData.length > 1) {
            if (selectedReeferData.length == selectedReeferData.filter(row => row.Status.trim().toUpperCase() == 'AWAITINGPREREQUISITES' || row.Status.trim().toUpperCase() == 'PENDING' || row.Status.trim().toUpperCase() == 'RETRY' || row.Status.trim().toUpperCase() == 'AWAITINGSYNC').length) {
                $('#liCancelRequiresRight').removeClass('disabled');
                $('#liCancelRequiresRight').addClass('enabled');
            }
            else {
                $('#liCancelRequiresRight').removeClass('enabled');
                $('#liCancelRequiresRight').addClass('disabled');
            }
        }
        else {
            var dflag = selectedReeferData[0].Status;
            if (dflag.trim().toUpperCase() == 'AWAITINGPREREQUISITES' || dflag.trim().toUpperCase() == 'PENDING' || dflag.trim().toUpperCase() == 'RETRY' || dflag.trim().toUpperCase() == 'AWAITINGSYNC') {
                $('#liCancelRequiresRight').removeClass('disabled');
                $('#liCancelRequiresRight').addClass('enabled');
            } else {
                $('#liCancelRequiresRight').removeClass('enabled');
                $('#liCancelRequiresRight').addClass('disabled');
            }
        }
    }

    ValidateHistoryDates() {
        var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = this.state.CommandStatusFilters.FromDate;
        var toDttm = this.state.CommandStatusFilters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    ApplyCommandStatusFilter() {
        var message = this.ValidateHistoryDates();
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }

        $('#globalLoader').show();
        this.state.CommandStatusFilters.FromDate = DateFormat(new Date(this.state.CommandStatusFilters.FromDate), 'mm/dd/yyyy HH:MM');
        this.state.CommandStatusFilters.ToDate = DateFormat(new Date(this.state.CommandStatusFilters.ToDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(this.state.CommandStatusFilters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryCommandStatusDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.CommandStatusUI[]>)
            .then(data => {
                this.setState({
                    rowData: data
                });

                //self.state.gridApiParams.paginationGoToFirstPage();
                $('#globalLoader').hide();
            });
    }

    ClearCommandStatusFilter() {
        var filters = this.state.CommandStatusFilters;
        filters.ReeferIds = "";
        filters.RcdIds = "";
        filters.UserId = -1;
        filters.CommandTypeCd = "-1";
        filters.CommandStatusId = -1;
        var modifiedDttm = this.state.PreferenceDTTM;
        var fromDate = moment(new Date(modifiedDttm)).startOf('day').toString();
        var toDate = moment(new Date(modifiedDttm)).endOf('day').toString();
        filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        this.setState({
            CommandStatusFilters: filters
        });
    }

    createColumnDefs() {
        return [
            { headerName: "Dry ID", field: "DryID", cellRenderer: Formatters.stringTypeFormatter, width: 140 },
            { headerName: "Device ID", field: "RcdID", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Command", field: "Command", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Status time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "StatusDate", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            //{ headerName: "RFR Pwr", field: "ReeferSwitchOn", cellRenderer: Formatters.reeferPowerSourceConverter, width: 100 },
           // { headerName: "Device Pwr", field: "RcdPowerSourceCd", cellRenderer: Formatters.rcdPowerSourceConverter, width: 100 },
            { headerName: "Status", field: "Status", cellRenderer: Formatters.commandLogStatusFormatter, width: 100 },
            { headerName: "Info", field: "Info", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Deployment name", field: "DeploymentName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Submitted time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "SubmittedOn", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Submitted by", field: "SubmittedBy", cellRenderer: Formatters.stringTypeFormatter, width: 130 },
            { headerName: "Expiration time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "ExpirationTime", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            //{ headerName: "Origin", field: "Origin", cellRenderer: Formatters.stringTypeFormatter, width: 100 },
            //{ headerName: "Handler", field: "Handler", cellRenderer: Formatters.stringTypeFormatter, width: 100 },
            { headerName: "Value1", field: "Value1", cellRenderer: Formatters.stringTypeFormatter, width: 100 },
            { headerName: "Value2", field: "Value2", cellRenderer: Formatters.stringTypeFormatter, width: 100 },
            { headerName: "Value3", field: "Value3", cellRenderer: Formatters.stringTypeFormatter, width: 100 },
            { headerName: "Value4", field: "Value4", cellRenderer: Formatters.stringTypeFormatter, width: 100 }
        ];
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        //self.state.gridApiParams.paginationGoToFirstPage();
    }

    onGridScroll(params: any) {
        $(".context-menu").hide();
        $("#contextmenu").hide();
    }

    public render() {
        return <div>
            <div id='divMsboxDynamicContent'></div>
            <div className='control_container'>
                <div className='row'>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'>Container Id:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className='input-group'>
                            <input type='text' className='form-control' placeholder='Container Id' onChange={e => this.DryIdchange(e)} value={this.state.CommandStatusFilters.ReeferIds} />
                        </div>
                    </div>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'>Device Id:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className='input-group'>
                            <input type='text' className='form-control' placeholder='Device Id' onChange={e => this.RcdIdchange(e)} value={this.state.CommandStatusFilters.RcdIds} />
                        </div>
                    </div>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'>Submitted From:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className="input-group date">
                            
	                    <DatePicker
		                    selected={new Date(this.state.CommandStatusFilters.FromDate)}
		                    maxDate={new Date(this.state.PreferenceDTTM)}
		                    onChange={this.CommandFromDateChange.bind(this)}
		                    timeInputLabel="Time:"
                            showYearDropdown
                            yearDropdownItemNumber={5}
		                    dateFormat="MM/dd/yyyy hh:mm aa"
		                    showTimeInput  
		                    className=""                          
	                    />
                           
                        </div>
                    </div>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'>Status:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className='input-group'>
                            <select className='form-control' onChange={e => this.Statuschange(e)} value={this.state.CommandStatusFilters.CommandStatusId}>
                                <option>-Select-</option>
                                {
                                    this.state.CommandStatus.map(status =>
                                        <option key={status.CommandStatusID} value={status.CommandStatusID}>{status.Description}</option>
                                    )}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row mt-1'>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'> Submitted By:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className='input-group'>
                            <select className='form-control' onChange={e => this.Userchange(e)} value={this.state.CommandStatusFilters.UserId}>
                                <option>-Select-</option>
                                {
                                    this.state.UserList.map(user =>
                                        <option key={user.UserId} value={user.UserId}>{user.UserName}</option>
                                    )}
                            </select>
                        </div>
                    </div>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'>Command:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className='input-group'>
                            <select className='form-control' onChange={e => this.CommandTypechange(e)} value={this.state.CommandStatusFilters.CommandTypeCd}>
                                <option>-Select-</option>
                                {
                                    this.state.CommandTypes.map(command =>
                                        <option key={command.CommandTypeCd} value={command.CommandTypeCd}>{command.Description}</option>
                                    )}
                            </select>
                        </div>
                    </div>
                    <div className='col-md-1 px-0'>
                        <label className='float-end col-form-label'> Submitted To:</label>
                    </div>
                    <div className='col-md-2'>
                        <div className="input-group date">
                            <DatePicker
		                        selected={new Date(this.state.CommandStatusFilters.ToDate)}
		                        maxDate={new Date(this.state.PreferenceDTTM)}
		                        onChange={this.CommandToDateChange.bind(this)}
		                        timeInputLabel="Time:"
                                showYearDropdown
                                yearDropdownItemNumber={5}
		                        dateFormat="MM/dd/yyyy hh:mm aa"
		                        showTimeInput
		                        className=""    
	                        />  
                        </div>
                    </div>
                    <div className="col-md-3" >
                        <div className='float-end'>
                            <button type='button' onClick={this.ClearCommandStatusFilter.bind(this)} className='btn btn-primary'>Clear</button>
                            <button type='button' onClick={this.ApplyCommandStatusFilter.bind(this)} className='btn btn-primary ms-2'>Search</button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <GridToolBar refreshGrid={this.ApplyCommandStatusFilter.bind(this)} gridData={this.state.rowData} colDefs={this.state.columnDefs} parentchild={"P"} formName={"ReeferDetailsCommandStatus"} />
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="ag-theme-fresh" id="CommandStatusGrid">
                        <AgGridReact
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            onGridReady={this.onGridReady}                            
                            pagination={true}
                            accentedSort={true}
                            rowSelection={'multiple'}
                            rowDeselection={true}
                            onSelectionChanged={this.onSelectionChanged}
                            allowContextMenuWithControlKey={true}
                            onCellContextMenu={this.getContextMenuItems}
                            paginationPageSize={this.state.pageSize}
                            onBodyScroll={this.onGridScroll}>
                        </AgGridReact>
                    </div>
                    <div className='pageSize'>
                        <span className='pageSize-lable'>Page Size:</span>
                        <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="contextMenuModel" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" id="contextMenuModelHeader">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                           
                        </div>
                        <div className="modal-body">
                            {this.state.popUpHtml}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

class DryCommandStatusFilters {
    ReeferIds: string;
    RcdIds: string;
    CommandTypeCd: string;
    FromDate: string;
    ToDate: string;
    CommandStatusId?: number;
    UserId: number;
}
class ValidationSeverityResult {
    Serverity: string;
    Result: string;
}
class ForwardCommandParams {
    SelectedReefers: server.CommandStatusUI[];
    CommandName: string;
}
